module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d513452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/head/header1.vue
// module id = 1106
// module chunks = 1